import { CustomerStore } from "@Front/Stores/CustomerStore";
import { ThirdPartyStore } from "@Front/Stores/ThirdPartyStore";
import { UserStore } from "@Front/Stores/UserStore";

export function createSessionRefreshStoreSubscriptions(
	schedule: () => void,
	idle: () => void,
): Array<() => void> {
	return [
		UserStore.instance.onConnect(schedule),
		UserStore.instance.onDisconnect(idle),
		CustomerStore.instance.onConnect(schedule),
		CustomerStore.instance.onDisconnect(idle),
		ThirdPartyStore.instance.onConnect(schedule),
		ThirdPartyStore.instance.onDisconnect(idle),
	];
}

export function cleanupStoreSubscriptions(unsubscribeFns: Array<() => void>): void {
	while (unsubscribeFns.length > 0) {
		const unsubscribe = unsubscribeFns.pop();
		try {
			unsubscribe?.();
		} catch {
			// ignore unsubscribe errors
		}
	}
}
